import { PROPERTY } from 'customer-data-filters-ui/converters/objectSeg/ObjectSegFilterTypes';
import getIn from 'transmute/getIn';
import toValueComparison from './util/toValueComparison';
import Raven from 'raven-js';
const toPropertyFilter = (operator, options) => {
  const filter = {
    filterType: PROPERTY,
    operation: toValueComparison(operator, options),
    property: getIn(['field', 'name'], operator)
  };
  const context = getIn(['field', 'context'], operator);
  const contextType = getIn(['field', 'contextType'], operator);
  if (typeof context === 'string' && contextType === 'UnifiedEvent') {
    filter.contextType = 'UE';
    filter.context = context;
  }
  if (contextType && contextType !== 'UnifiedEvent') {
    Raven.captureException(new Error(`Unexpected context type: ${contextType} with context: ${context} for property: ${getIn(['field', 'name'], operator)}`));
  }
  return filter;
};
export default toPropertyFilter;